import {useParams} from 'react-router'
import SupplierCustomerScreen from './index'

const SupplierCustomerScreenParamWrapper = (props) => {
  const {customerId} = useParams()
  return <SupplierCustomerScreen customerId={customerId} {...props} />
}

export default SupplierCustomerScreenParamWrapper
